import React, { useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Mail, Phone, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PhaseContact({ data, onNext, onBack, loading, draftId }) {
  const [formData, setFormData] = useState({
    email: data.email || "",
    phone: data.phone || "",
    mobile: data.mobile || ""
  });
  const [emailSent, setEmailSent] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleContinue = async () => {
    if (!formData.email) {
      toast.error("El email es requerido");
      return;
    }

    // Note: Email verification will be sent after customer is created
    // For now, just save the data
    setEmailSent(true);
    toast.info("✉️ El correo de verificación se enviará al crear el cliente");
    
    onNext(formData);
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-xl font-semibold text-white mb-2">Datos de Contacto</h2>
        <p className="text-slate-400 text-sm">Información para comunicarnos con el cliente</p>
      </div>

      <div className="max-w-md mx-auto space-y-4">
        <div>
          <Label className="text-slate-300 text-sm flex items-center gap-2">
            <Mail size={16} /> Email *
          </Label>
          <Input 
            type="email"
            name="email" 
            value={formData.email} 
            onChange={handleChange} 
            placeholder="ejemplo@correo.com"
            className="bg-slate-800 border-slate-700 text-white"
          />
          <p className="text-xs text-slate-500 mt-1">Se enviará un correo de verificación</p>
        </div>

        <div>
          <Label className="text-slate-300 text-sm flex items-center gap-2">
            <Phone size={16} /> Teléfono
          </Label>
          <Input 
            type="tel"
            name="phone" 
            value={formData.phone} 
            onChange={handleChange} 
            placeholder="(55) 1234-5678"
            className="bg-slate-800 border-slate-700 text-white"
          />
        </div>

        <div>
          <Label className="text-slate-300 text-sm flex items-center gap-2">
            <Phone size={16} /> Móvil
          </Label>
          <Input 
            type="tel"
            name="mobile" 
            value={formData.mobile} 
            onChange={handleChange} 
            placeholder="(55) 9876-5432"
            className="bg-slate-800 border-slate-700 text-white"
          />
        </div>

        {emailSent && (
          <div className="bg-teal-500/10 border border-teal-500/30 rounded-lg p-3">
            <p className="text-teal-400 text-sm">
              <CheckCircle2 size={16} className="inline mr-2" />
              Correo de verificación pendiente de envío
            </p>
          </div>
        )}
      </div>

      <div className="flex justify-between mt-8">
        <Button onClick={onBack} variant="outline" className="border-slate-700">
          ← Atrás
        </Button>
        <Button
          onClick={handleContinue}
          disabled={!formData.email || loading}
          className="bg-teal-600 hover:bg-teal-500 text-white"
        >
          Continuar →
        </Button>
      </div>
    </div>
  );
}
